import React from 'react';
import { EventFormEditor } from '../../presentational/EventFormEditor';
import { EventFormValues } from '../../presentational/hooks/useEventFormState';
import { FormType } from '@graphql/generated';
import { EventFormData, FormSettings } from '../shared/types';
import { parseFormSettings } from '../shared/parseFormSettings';
import { useAnswerByGuestSession } from '../shared/hooks/useAnswerByGuestSession';
import { TextV2 } from '@withjoy/joykit';
import { useSaveBasicForm } from './hooks/useSaveBasicForm';

type BasicFormProps = {
  formData: EventFormData & { type: FormType.OTHER | FormType.SURVEY };
  onComplete?: (values: EventFormValues) => void;
};

export const BasicForm = (props: BasicFormProps) => {
  const { formData, onComplete } = props;
  const baseSettings = parseFormSettings(formData.settings);
  const { loading, answers, contact, guestKey } = useAnswerByGuestSession(formData.id, formData.eventId ?? '');
  const { saveBasicForm } = useSaveBasicForm();

  // For basic forms, we consider it submitted if they have answered any questions
  const hasSubmitted = Object.keys(answers).length > 0;

  const settings: FormSettings = baseSettings;

  if (loading) {
    return <TextV2>Loading...</TextV2>;
  }

  const initialData = hasSubmitted
    ? {
        formValues: answers,
        attendanceValue: null,
      }
    : undefined;

  return (
    <EventFormEditor
      isFormDisabled={!formData.enabled}
      formType={formData.type}
      settings={{
        isRegistration: false,
        ...settings,
      }}
      formData={formData.config}
      initialData={initialData}
      guestInfo={{
        showConfirmation: guestKey !== undefined && contact !== undefined,
        guestDisplayName: contact ? `${contact.firstName} ${contact.lastName}` : '',
        hasSubmitted,
      }}
      onSubmit={(values: EventFormValues) => {
        // eslint-disable-next-line no-console
        console.log('Submitted basic form values:', values);
        saveBasicForm({ ...values, formId: formData.id, guestKey: guestKey ?? undefined }).then(() => {
          onComplete?.(values);
        });
      }}
    />
  );
};
